export default __webpack_public_path__ + "static/media/burger.b93d390e.svg";